import { render } from "./tab_certificates.vue?vue&type=template&id=5b321315"
import script from "./tab_certificates.vue?vue&type=script&lang=js"
export * from "./tab_certificates.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__